import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  assetDataService,
  assetSharedModelService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './copy-asset-type-dialog.controller';
import template from './copy-asset-type-dialog.html';
import validator, { name as validatorName } from './messages/unique-asset-type-name.validator.directive';
import nameMessagesTpl from './messages/name.messages.html';

export class dialogService {
  getOptions($event, {
    assetType,
  }) {
    return {
      controller,
      controllerAs: 'copyAssetTypeDialogVM',
      locals: {
        assetType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.assetAdministration.copyAssetTypeDialog', [
  ssDialogService,
  loaderService,
  assetDataService,
  alerts,
  assetSharedModelService,
])
  .directive(validatorName, validator)
  .service('copyAssetTypeDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('asset-type.name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.admin.assetAdministration.copyAssetTypeDialog created');
